import { VFlow } from 'bold-ui'
import { IvcfSubgrupoPerguntaEnum } from 'graphql/types.generated'

import { IVCF_SUBGRUPOS } from '../../model-ivcf'
import { IvcfSubgrupoWrapper } from '../components/IvcfSubgrupoWrapper'
import { IvcfPerguntaField } from './IvcfPerguntaField'

interface IvcfSubgrupoFieldProps {
  ivcfPath: any
  subgrupo: IvcfSubgrupoPerguntaEnum
  isEditing?: boolean
  readOnly?: boolean
}

export function IvcfSubgrupoField(props: IvcfSubgrupoFieldProps) {
  const { ivcfPath, subgrupo, isEditing, readOnly } = props
  const { perguntas } = IVCF_SUBGRUPOS[subgrupo]

  return (
    <IvcfSubgrupoWrapper subgrupo={subgrupo} isEditing={isEditing}>
      <VFlow vSpacing={0}>
        {perguntas.map((pergunta) => (
          <IvcfPerguntaField
            key={pergunta}
            ivcfPath={ivcfPath}
            pergunta={pergunta}
            isEditing={isEditing}
            readOnly={readOnly}
          />
        ))}
      </VFlow>
    </IvcfSubgrupoWrapper>
  )
}
